import {HeaderPattern} from '../shared/utils/header-list';
import {RolesEnum, Routes} from '../shared/utils/routes';
import config from './config.json';

export const headerLists: HeaderPattern[] = [
  {
    title: 'bookingOverview',
    icon: 'bi bi-graph-up',
    path: Routes.BookingOverview,
    role: [RolesEnum.AdminRole, RolesEnum.EditorRole, RolesEnum.ViewerRole],
    isEnabled: config.bookingOverview.enabled
  },
  {
    title: 'revenueManager',
    icon: 'bi bi-graph-up',
    path: Routes.RevenueManager,
    role: [RolesEnum.AdminRole, RolesEnum.EditorRole, RolesEnum.ViewerRole],
    isEnabled: config.revenueManager.enabled
  }
];

